import { DadosPausarType } from "../types";

export function mapperDadosPausar(data: string): DadosPausarType {
  const dadosObj = data

    .trim()
    .split(";")
    .reduce(
      (a, c, i) => ({
        ...a,
        [["idUsuario", "idGrupo", "idRetorno", "descRetorno"][i]]: c,
      }),
      {}
    );

  return dadosObj as DadosPausarType;
}
